import Footer from '../components/Footer/Footer'
import Navbar from "../components/Navbar/Navbar"
import { labFacilities } from '../common/config/constants'
import CardWithModal from '../components/CardWithModal/CardWithModal'

const style={
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}

const LabFacilities = () => {
    return (
        <>
            <Navbar />
            <div className="container shadow-lg flex-fill">
                <div className="row">
                    {
                        labFacilities.map((item, index) => (
                            <div className="col-12 col-md-4 d-flex mt-1 mb-1 card-container" style={style}>
                                <CardWithModal details={item} key={index} />
                            </div>
                        ))
                    }
                </div>
            </div>
            <Footer />
        </>
    )
}

export default LabFacilities;